export default __webpack_public_path__ + "static/media/container.084d7304.jpg";